/* Postrly evergreen timer — recurring countdown (default 48h) shared by
   every [data-postrly-evertimer] on the page. Anchored in localStorage so
   it persists across pages/visits and resets automatically when it hits
   zero. Honest framing: a rolling campaign window, not a fake deadline. */
(function () {
  'use strict';
  var KEY = 'postrly_evergreen_anchor_v1';

  function anchor() {
    var a = null;
    try { a = parseInt(localStorage.getItem(KEY), 10); } catch (e) {}
    if (!a || isNaN(a) || a > Date.now()) {
      a = Date.now();
      try { localStorage.setItem(KEY, String(a)); } catch (e) {}
    }
    return a;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function build(el) {
    if (el.dataset.built) return;
    el.dataset.built = '1';
    var showDays = el.getAttribute('data-days') !== 'false';
    var groups = showDays ? [['d','Days'],['h','Hours'],['m','Mins'],['s','Secs']] : [['h','Hours'],['m','Mins'],['s','Secs']];
    var labels = el.getAttribute('data-labels') !== 'false';
    var html = '';
    groups.forEach(function (g, i) {
      if (i) html += '<span class="ptimer__sep" aria-hidden="true">:</span>';
      html += '<span class="ptimer__group"><span class="ptimer__num" data-t-' + g[0] + '>00</span>' + (labels ? '<span class="ptimer__lbl">' + g[1] + '</span>' : '') + '</span>';
    });
    el.innerHTML = html;
    el.classList.add('ptimer');
    el.setAttribute('role', 'timer');
  }

  function tickAll() {
    var els = document.querySelectorAll('[data-postrly-evertimer]');
    if (!els.length) return;
    var now = Date.now();
    els.forEach(function (el) {
      build(el);
      var hours = parseFloat(el.getAttribute('data-hours')) || 48;
      var dur = hours * 3600000;
      var rem = dur - ((now - anchor()) % dur);
      var t = Math.floor(rem / 1000);
      var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
      var showDays = el.getAttribute('data-days') !== 'false';
      if (!showDays) h = h + d * 24;
      var map = { d: pad(d), h: pad(h), m: pad(m), s: pad(s) };
      ['d','h','m','s'].forEach(function (k) {
        var n = el.querySelector('[data-t-' + k + ']');
        if (n && n.textContent !== map[k]) n.textContent = map[k];
      });
    });
  }

  function start() { tickAll(); setInterval(tickAll, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
